import { Menu, styled, Typography } from '@/shared/ui';

export const UserMenuTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey['700'],
}));

export const UserMenu = styled(Menu)(({ theme }) => ({
  '& .MuiList-root': {
    padding: theme.spacing(2),
  },
}));
